import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { MotivoPerdaVendaPLMFormComponent } from './motivo-perda-venda-plm-form.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        MotivoPerdaVendaPLMFormComponent
    ],
    exports: [
        MotivoPerdaVendaPLMFormComponent
    ]
})
export class MotivoPerdaVendaPLMFormModule { }
